import { useState, useEffect } from "react";
import axios from "../axios";
import { toast } from "react-toastify";

const useTasks = (page, limit, start, end, id, today, thisWeek, checkData) => {
  const [employeeTaksData, setEmployeeTaksData] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [pagination, setPagination] = useState({});

  useEffect(() => {
    const fetchTasks = async () => {
      const token = localStorage.getItem("salon");

      if (!token) {
        toast.error("Not authenticated");
        return;
      }

      setErrorMessage(null);

      try {
        const result = await axios.get(
          `employees/${id}/tasks?page=${page}&limit=${limit}&start=${start}&end=${end}&sort=date`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setEmployeeTaksData(result.data.data);
        setPagination(result.data.pagination);
      } catch (error) {
        const errorMsg = error.response?.data?.error?.message || error.message;
        setErrorMessage(errorMsg);
        toast.error(`Алдаа: ${errorMsg}`);
      }
    };

    if (id) {
      fetchTasks();
    }
  }, [id, page, limit, start, end, today, thisWeek, checkData]);

  return [employeeTaksData, errorMessage, pagination];
};

export default useTasks;
